var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElitebadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Elitebadge_svg__filter0_d_5736_26101)",
    clipPath: "url(#Elitebadge_svg__clip0_5736_26101)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 46.465c-.94 0-1.939-.268-2.905-.528-.96-.259-1.955-.525-2.88-.525-.926 0-1.92.266-2.881.525-.965.26-1.964.528-2.905.528-.455 0-.86-.06-1.241-.185-1.36-.441-2.318-1.636-3.243-2.79-.63-.785-1.225-1.528-1.93-2.042-.717-.522-1.657-.88-2.566-1.226-1.375-.524-2.796-1.064-3.625-2.204-.82-1.126-.897-2.638-.973-4.1-.05-.98-.102-1.99-.38-2.848-.263-.809-.777-1.592-1.322-2.423-.819-1.244-1.665-2.532-1.665-3.994 0-1.461.846-2.747 1.665-3.993.545-.83 1.059-1.613 1.322-2.422.28-.857.331-1.868.38-2.847.076-1.461.153-2.973.973-4.1.83-1.14 2.25-1.681 3.625-2.204.91-.347 1.849-.705 2.566-1.227.705-.512 1.3-1.255 1.93-2.04.925-1.156 1.882-2.35 3.244-2.79a3.985 3.985 0 011.241-.185c.941 0 1.94.268 2.906.528.96.259 1.954.525 2.88.525.925 0 1.92-.266 2.88-.525.967-.26 1.965-.528 2.906-.528.454 0 .86.06 1.239.184 1.36.442 2.32 1.637 3.245 2.791.63.785 1.224 1.528 1.93 2.04.717.522 1.656.88 2.566 1.227 1.375.523 2.795 1.064 3.624 2.204.82 1.125.897 2.637.973 4.1.05.98.102 1.99.38 2.847.263.81.777 1.593 1.323 2.422.818 1.245 1.665 2.532 1.665 3.993 0 1.462-.847 2.748-1.665 3.994-.546.829-1.06 1.613-1.323 2.423-.279.856-.33 1.868-.38 2.847-.076 1.462-.153 2.974-.973 4.1-.829 1.14-2.25 1.681-3.624 2.205-.91.347-1.85.704-2.567 1.226-.705.513-1.299 1.255-1.93 2.04-.925 1.156-1.882 2.35-3.244 2.79a3.984 3.984 0 01-1.24.185v.002z",
    fill: "url(#Elitebadge_svg__paint0_linear_5736_26101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.848 24.657c0 2.317-2.295 4.244-2.974 6.334-.704 2.168-.004 5.07-1.317 6.874-1.326 1.822-4.312 2.046-6.134 3.372-1.804 1.313-2.933 4.091-5.1 4.794-2.09.68-4.628-.883-6.945-.883-2.318 0-4.854 1.561-6.945.883-2.168-.703-3.296-3.48-5.1-4.794-1.822-1.326-4.808-1.55-6.134-3.372-1.313-1.804-.612-4.706-1.317-6.874-.68-2.09-2.975-4.017-2.975-6.334 0-2.318 2.296-4.244 2.974-6.335.703-2.168.003-5.07 1.316-6.874 1.326-1.822 4.312-2.046 6.135-3.372 1.803-1.313 2.932-4.091 5.1-4.794 2.09-.68 4.627.883 6.944.883 2.318 0 4.855-1.561 6.945-.883 2.168.703 3.297 3.48 5.1 4.794 1.823 1.326 4.809 1.55 6.135 3.372 1.313 1.804.611 4.706 1.316 6.874.68 2.09 2.975 4.017 2.975 6.335h.001z",
    fill: "url(#Elitebadge_svg__paint1_linear_5736_26101)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 45.15c-.767 0-1.64-.235-2.563-.483-1.044-.28-2.122-.57-3.223-.57-1.1 0-2.178.29-3.222.57-.924.25-1.796.483-2.563.483a2.67 2.67 0 01-.834-.12c-.987-.32-1.784-1.312-2.625-2.363-.656-.818-1.336-1.665-2.182-2.281-.86-.625-1.883-1.016-2.873-1.392-1.25-.477-2.43-.926-3.03-1.749-.59-.81-.654-2.065-.724-3.394-.055-1.064-.111-2.163-.443-3.185-.316-.977-.906-1.873-1.474-2.738-.744-1.134-1.448-2.203-1.448-3.271 0-1.07.703-2.138 1.448-3.272.57-.865 1.158-1.76 1.474-2.738.332-1.022.388-2.122.443-3.185.068-1.329.133-2.584.722-3.394.6-.823 1.78-1.272 3.03-1.749.99-.376 2.014-.766 2.873-1.392.847-.616 1.525-1.463 2.182-2.281.842-1.05 1.636-2.042 2.625-2.363.247-.08.52-.12.834-.12.768 0 1.64.235 2.563.482 1.044.281 2.122.571 3.223.571 1.1 0 2.179-.29 3.22-.57.925-.25 1.798-.483 2.564-.483.314 0 .587.04.834.12.987.32 1.783 1.313 2.625 2.363.656.818 1.336 1.665 2.182 2.281.86.626 1.883 1.016 2.873 1.392 1.25.476 2.429.926 3.03 1.749.59.81.654 2.065.723 3.394.056 1.064.112 2.163.443 3.185.317.977.907 1.873 1.474 2.738.745 1.134 1.45 2.204 1.45 3.271 0 1.068-.704 2.138-1.45 3.272-.569.865-1.157 1.76-1.474 2.738-.33 1.022-.388 2.122-.443 3.185-.067 1.329-.132 2.584-.723 3.394-.6.823-1.78 1.272-3.03 1.749-.99.376-2.014.766-2.873 1.392-.846.616-1.526 1.463-2.182 2.28-.842 1.05-1.636 2.043-2.625 2.364-.247.08-.52.12-.834.12h.003z",
    fill: "url(#Elitebadge_svg__paint2_linear_5736_26101)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 45.15c-.767 0-1.64-.235-2.563-.483-1.044-.28-2.122-.57-3.223-.57-1.1 0-2.178.29-3.222.57-.924.25-1.796.483-2.563.483a2.67 2.67 0 01-.834-.12c-.987-.32-1.784-1.312-2.625-2.363-.656-.818-1.336-1.665-2.182-2.281-.86-.625-1.883-1.016-2.873-1.392-1.25-.477-2.43-.926-3.03-1.749-.59-.81-.654-2.065-.724-3.394-.055-1.064-.111-2.163-.443-3.185-.316-.977-.906-1.873-1.474-2.738-.744-1.134-1.448-2.203-1.448-3.271 0-1.07.703-2.138 1.448-3.272.57-.865 1.158-1.76 1.474-2.738.332-1.022.388-2.122.443-3.185.068-1.329.133-2.584.722-3.394.6-.823 1.78-1.272 3.03-1.749.99-.376 2.014-.766 2.873-1.392.847-.616 1.525-1.463 2.182-2.281.842-1.05 1.636-2.042 2.625-2.363.247-.08.52-.12.834-.12.768 0 1.64.235 2.563.482 1.044.281 2.122.571 3.223.571 1.1 0 2.179-.29 3.22-.57.925-.25 1.798-.483 2.564-.483.314 0 .587.04.834.12.987.32 1.783 1.313 2.625 2.363.656.818 1.336 1.665 2.182 2.281.86.626 1.883 1.016 2.873 1.392 1.25.476 2.429.926 3.03 1.749.59.81.654 2.065.723 3.394.056 1.064.112 2.163.443 3.185.317.977.907 1.873 1.474 2.738.745 1.134 1.45 2.204 1.45 3.271 0 1.068-.704 2.138-1.45 3.272-.569.865-1.157 1.76-1.474 2.738-.33 1.022-.388 2.122-.443 3.185-.067 1.329-.132 2.584-.723 3.394-.6.823-1.78 1.272-3.03 1.749-.99.376-2.014.766-2.873 1.392-.846.616-1.526 1.463-2.182 2.28-.842 1.05-1.636 2.043-2.625 2.364-.247.08-.52.12-.834.12h.003z",
    fill: "url(#Elitebadge_svg__paint3_linear_5736_26101)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 44.098c-.628 0-1.435-.215-2.29-.446-1.11-.3-2.258-.607-3.496-.607s-2.385.31-3.495.607c-.855.23-1.662.446-2.29.448-.203 0-.368-.022-.51-.068-.689-.224-1.389-1.095-2.128-2.02-.7-.874-1.422-1.776-2.384-2.474-.973-.708-2.064-1.123-3.117-1.525-1.099-.418-2.138-.813-2.554-1.384-.407-.558-.463-1.662-.523-2.83-.059-1.132-.119-2.302-.494-3.456-.36-1.111-.988-2.067-1.595-2.99-.656-.999-1.276-1.941-1.276-2.695 0-.754.62-1.696 1.276-2.694.607-.924 1.234-1.88 1.595-2.99.375-1.155.435-2.325.494-3.455.06-1.17.116-2.274.523-2.83.416-.57 1.454-.966 2.554-1.386 1.055-.402 2.146-.817 3.117-1.524.96-.699 1.684-1.6 2.382-2.474.741-.925 1.441-1.797 2.13-2.021a1.66 1.66 0 01.51-.068c.628 0 1.435.218 2.29.448 1.11.298 2.256.607 3.495.607 1.24 0 2.385-.31 3.494-.607.856-.23 1.663-.448 2.292-.448.202 0 .367.022.51.068.688.224 1.387 1.096 2.127 2.021.7.873 1.424 1.775 2.384 2.474.973.707 2.062 1.122 3.117 1.524 1.1.42 2.14.815 2.554 1.386.407.558.464 1.662.523 2.83.059 1.132.119 2.302.494 3.456.361 1.111.989 2.066 1.595 2.99.656.998 1.276 1.941 1.276 2.695 0 .753-.62 1.696-1.276 2.692-.606.924-1.236 1.88-1.597 2.993-.375 1.154-.435 2.324-.493 3.456-.06 1.168-.117 2.271-.523 2.83-.417.57-1.454.966-2.554 1.384-1.055.402-2.145.816-3.117 1.524-.96.698-1.684 1.602-2.384 2.474-.741.924-1.441 1.797-2.128 2.02a1.653 1.653 0 01-.51.069l.002-.004z",
    fill: "#03070A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.936 16.049s-.81-1.142-1.578-1.22c-.687-.073-1.366.16-1.366.16s1.444 1.033 2.133 1.235c.534.157.81-.175.81-.175h.001z",
    fill: "url(#Elitebadge_svg__paint4_radial_5736_26101)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.199 29.13s.357.244.815-.171c.59-.535 1.35-2.672 1.35-2.672s-.654.381-1.2.895c-.612.574-.965 1.947-.965 1.947z",
    fill: "url(#Elitebadge_svg__paint5_radial_5736_26101)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 31.425c.803-1.728 1.26-3.619 1.356-5.62.063.018.42.102.76-.362.482-.659.846-2.923.846-2.923s-.572.525-1.018 1.156c-.394.558-.54 1.562-.583 1.958.008-.205.014-.408.014-.615 0-.903-.074-1.797-.211-2.672.134-.024.403-.126.578-.568.31-.779.115-3.064.115-3.064s-.425.674-.703 1.414c-.143.381-.169.883-.156 1.314a16.682 16.682 0 00-.71-2.42c.106-.034.401-.174.507-.698.168-.832-.432-3.03-.432-3.03s-.295.755-.437 1.542c-.096.53.041 1.218.164 1.682a16.19 16.19 0 00-1.362-2.58c.077-.04.383-.231.39-.808.012-.853-1.013-2.87-1.013-2.87s-.143.803-.13 1.606c.009.67.416 1.502.619 1.877a16.1 16.1 0 00-1.112-1.463c-.096-.306-.4-1.026-1.258-1.583-1-.65-2.65-1.286-2.65-1.286s1.77 1.69 2.685 2.38c.544.412.993.566 1.173.615a15.714 15.714 0 012.562 4.19c-.237-.393-.612-.907-1.042-1.054-.65-.22-1.347-.142-1.347-.142s1.195 1.326 1.828 1.675c.375.206.654.102.766.04.366.978.641 1.996.818 3.043-.126-.411-.44-1.272-.938-1.572-.594-.359-1.286-.433-1.286-.433s.928 1.56 1.486 2.043c.367.317.686.232.774.199a17.16 17.16 0 01.186 3.4c-.014-.181-.137-1.46-.68-1.96-.521-.485-1.186-.71-1.186-.71s.645 1.735 1.113 2.331c.345.44.717.37.752.363a15.34 15.34 0 01-.506 3.233c.02-.29.075-1.456-.346-2.03-.433-.59-1.048-.959-1.048-.959s.347 1.846.706 2.535c.256.488.609.52.67.52a14.344 14.344 0 01-1.095 2.812c.091-.442.22-1.312-.043-1.856a4.378 4.378 0 00-.869-1.171s.03 1.888.267 2.644c.135.432.386.586.507.637a14.597 14.597 0 01-2 2.815c.162-.38.495-1.274.321-1.904a4.647 4.647 0 00-.65-1.342s-.3 1.859-.206 2.652c.057.465.286.67.395.742-.103.11-.206.223-.313.331a16.241 16.241 0 01-1.735 1.516c.279-.376.652-.981.648-1.519-.008-.766-.287-1.485-.287-1.485s-.771 1.695-.888 2.483c-.063.42.07.673.16.796-.68.488-1.409.932-2.172 1.331.3-.22 1.1-.862 1.238-1.539.15-.749.014-1.515.014-1.515s-1.122 1.48-1.41 2.222c-.2.509-.01.83.035.897-.77.397-1.58.745-2.418 1.047.399-.202 1.24-.685 1.474-1.287.28-.716.259-1.493.259-1.493s-1.407 1.29-1.839 1.975c-.29.46-.159.801-.12.885a21.72 21.72 0 01-3.034.809 8.96 8.96 0 00-1.932.583 8.961 8.961 0 00-1.93-.583 21.353 21.353 0 01-3.036-.81c.041-.083.17-.423-.12-.884-.432-.685-1.838-1.975-1.838-1.975s-.02.777.259 1.493c.235.602 1.075 1.086 1.474 1.286a20.112 20.112 0 01-2.419-1.046c.046-.068.235-.388.037-.897-.289-.741-1.411-2.222-1.411-2.222s-.136.766.014 1.515c.135.678.938 1.32 1.237 1.539-.764-.4-1.491-.843-2.17-1.33.09-.122.22-.377.159-.797-.117-.788-.888-2.483-.888-2.483s-.28.72-.287 1.485c-.005.538.37 1.143.648 1.519a16.088 16.088 0 01-1.736-1.515c-.107-.11-.208-.221-.312-.332.109-.072.338-.279.394-.742.095-.792-.206-2.652-.206-2.652s-.448.609-.65 1.342c-.173.63.16 1.524.322 1.904a14.537 14.537 0 01-2-2.816c.122-.051.373-.204.507-.636.236-.756.266-2.644.266-2.644s-.542.498-.868 1.171c-.264.544-.134 1.414-.043 1.856a14.245 14.245 0 01-1.096-2.811c.06-.002.415-.033.669-.52.36-.688.706-2.536.706-2.536s-.615.37-1.048.959c-.421.574-.368 1.739-.345 2.03a15.343 15.343 0 01-.507-3.233c.035.008.407.079.752-.363.467-.596 1.114-2.331 1.114-2.331s-.666.225-1.188.71c-.54.5-.663 1.779-.68 1.96a17.172 17.172 0 01.186-3.4c.09.033.408.118.775-.199.558-.482 1.487-2.043 1.487-2.043s-.692.076-1.287.433c-.498.302-.812 1.162-.938 1.572.177-1.045.453-2.063.818-3.043.112.062.391.166.767-.04.632-.35 1.827-1.675 1.827-1.675s-.697-.079-1.346.142c-.43.147-.806.66-1.043 1.055a15.761 15.761 0 012.562-4.19c.181-.051.63-.206 1.173-.615.916-.693 2.685-2.381 2.685-2.381s-1.649.637-2.65 1.286c-.856.557-1.162 1.277-1.258 1.583-.4.465-.771.954-1.112 1.463.204-.377.61-1.209.62-1.877.013-.801-.13-1.607-.13-1.607s-1.026 2.018-1.015 2.871c.008.577.314.768.391.807a15.934 15.934 0 00-1.362 2.581c.123-.463.26-1.152.164-1.682-.142-.787-.437-1.542-.437-1.542s-.6 2.2-.432 3.03c.106.524.4.664.508.698a16.61 16.61 0 00-.71 2.42c.013-.431-.014-.933-.157-1.314a9.037 9.037 0 00-.703-1.415s-.194 2.287.115 3.065c.175.442.445.544.579.568a17.261 17.261 0 00-.212 2.672c0 .207.007.412.014.615-.044-.396-.189-1.4-.583-1.958-.446-.63-1.018-1.156-1.018-1.156s.364 2.264.846 2.923c.34.464.696.38.76.361.095 2.002.554 3.893 1.356 5.62-.23-.346-.53-.72-.853-.914-.627-.378-1.33-.6-1.33-.6s1.125 1.923 1.798 2.31c.42.24.699.08.793.007.451.833.987 1.622 1.604 2.366-.31-.277-.703-.57-1.072-.67-.694-.187-1.424-.203-1.424-.203s1.539 1.545 2.283 1.728c.471.115.7-.128.77-.222.106.115.212.23.322.343.406.41.84.8 1.296 1.17-.335-.195-.733-.377-1.083-.403-.717-.054-1.442.069-1.442.069s1.762 1.234 2.536 1.27c.486.024.677-.255.733-.364.65.472 1.344.904 2.072 1.295-.42-.196-1.143-.484-1.693-.434a7.188 7.188 0 00-1.449.31s1.975.92 2.775.825c.586-.07.697-.477.706-.523a20.4 20.4 0 002.221.974c-.479-.126-1.247-.279-1.787-.15-.754.18-1.45.529-1.45.529s2.2.605 3.026.387c.55-.145.639-.506.653-.607a21.63 21.63 0 003.024.804c.704.135 1.3.319 1.803.53-.744.345-1.27.744-1.633 1.1.042.015.087.029.128.042.368-.352.901-.743 1.652-1.077.75.334 1.283.725 1.652 1.077l.128-.041c-.363-.357-.888-.756-1.634-1.1a8.972 8.972 0 011.804-.53 21.63 21.63 0 003.024-.805c.014.101.104.462.652.607.827.218 3.027-.387 3.027-.387s-.696-.349-1.45-.529c-.54-.129-1.307.024-1.788.15.768-.284 1.51-.608 2.222-.974.01.044.12.452.706.523.8.096 2.775-.824 2.775-.824s-.713-.243-1.45-.31c-.55-.051-1.275.236-1.693.433.727-.393 1.421-.823 2.072-1.295.057.11.248.387.733.365.774-.038 2.537-1.271 2.537-1.271s-.725-.123-1.443-.07c-.35.027-.747.209-1.083.404.457-.37.891-.76 1.296-1.17.11-.112.216-.228.323-.343.07.094.298.337.77.222.744-.183 2.282-1.728 2.282-1.728s-.73.016-1.423.203c-.369.1-.761.393-1.072.67a14.56 14.56 0 001.603-2.366c.093.073.374.233.793-.008.673-.388 1.8-2.31 1.8-2.31s-.706.223-1.331.601c-.324.194-.623.568-.854.915h.002z",
    fill: "url(#Elitebadge_svg__paint6_radial_5736_26101)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.403 14.827c-.768.08-1.578 1.22-1.578 1.22s.276.331.81.175c.689-.202 2.133-1.234 2.133-1.234s-.678-.234-1.367-.161h.002z",
    fill: "url(#Elitebadge_svg__paint7_radial_5736_26101)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.562 29.13s-.353-1.372-.965-1.948a7.693 7.693 0 00-1.2-.895s.76 2.137 1.35 2.672c.457.415.815.17.815.17z",
    fill: "url(#Elitebadge_svg__paint8_radial_5736_26101)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.084 9.963l1.053-.662 1.051.662-.302-1.206.953-.798-1.24-.083-.462-1.154-.464 1.154-1.24.083.953.798-.302 1.206z",
    fill: "url(#Elitebadge_svg__paint9_radial_5736_26101)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 10.584l.128.639.348-.55.648.077-.414-.503.27-.591-.605.238-.477-.442.04.652-.568.318.63.162z",
    fill: "url(#Elitebadge_svg__paint10_radial_5736_26101)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73 10.212l.607-.676.874.252-.456-.787.511-.752-.89.191-.557-.719-.095.905-.854.31.83.367.03.91z",
    fill: "url(#Elitebadge_svg__paint11_radial_5736_26101)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.753 10.673l.35.55.128-.639.63-.162-.569-.319.041-.65-.479.44-.605-.237.273.591-.415.503.646-.077z",
    fill: "url(#Elitebadge_svg__paint12_radial_5736_26101)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.019 9.788l.873-.252.607.676.029-.91.832-.367-.856-.309-.093-.905-.558.72-.89-.192.511.752-.455.787z",
    fill: "url(#Elitebadge_svg__paint13_radial_5736_26101)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.937 16.246s-.81-1.142-1.579-1.22c-.687-.073-1.366.16-1.366.16s1.444 1.033 2.133 1.235c.534.157.81-.175.81-.175h.002z",
    fill: "url(#Elitebadge_svg__paint14_linear_5736_26101)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 29.326s.357.245.814-.17c.59-.534 1.35-2.672 1.35-2.672s-.653.381-1.2.895c-.612.574-.965 1.947-.965 1.947z",
    fill: "url(#Elitebadge_svg__paint15_linear_5736_26101)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 31.622c.803-1.728 1.26-3.619 1.356-5.62.063.018.42.102.76-.362.482-.659.846-2.923.846-2.923s-.572.525-1.018 1.156c-.394.558-.54 1.562-.583 1.958.008-.205.014-.408.014-.615 0-.903-.074-1.797-.211-2.672.134-.024.403-.126.578-.568.31-.778.115-3.064.115-3.064s-.425.674-.703 1.414c-.143.381-.168.883-.156 1.315a16.682 16.682 0 00-.71-2.42c.106-.035.401-.175.507-.699.169-.832-.432-3.03-.432-3.03s-.295.755-.437 1.542c-.096.53.041 1.219.164 1.682a16.186 16.186 0 00-1.362-2.58c.077-.04.383-.23.39-.808.012-.853-1.013-2.87-1.013-2.87s-.143.803-.13 1.606c.009.67.416 1.502.619 1.877a16.1 16.1 0 00-1.111-1.463c-.097-.306-.401-1.026-1.259-1.582-1-.65-2.65-1.287-2.65-1.287s1.77 1.69 2.685 2.38c.544.412.993.567 1.173.615a15.716 15.716 0 012.562 4.19c-.237-.393-.612-.907-1.042-1.054-.65-.22-1.347-.142-1.347-.142s1.195 1.326 1.828 1.675c.375.206.654.102.766.04.366.978.642 1.997.818 3.043-.126-.411-.44-1.272-.938-1.572-.594-.359-1.286-.433-1.286-.433s.928 1.56 1.486 2.043c.368.317.686.232.774.199a17.16 17.16 0 01.186 3.4c-.014-.18-.137-1.46-.68-1.96-.52-.485-1.186-.71-1.186-.71s.645 1.735 1.113 2.331c.345.44.717.37.752.363a15.34 15.34 0 01-.506 3.233c.02-.29.075-1.456-.346-2.03-.433-.59-1.048-.959-1.048-.959s.347 1.848.706 2.536c.256.487.609.518.67.52a14.34 14.34 0 01-1.095 2.81c.091-.44.22-1.311-.043-1.855a4.378 4.378 0 00-.868-1.171s.03 1.889.266 2.644c.135.432.386.586.508.637a14.6 14.6 0 01-2.001 2.815c.162-.38.495-1.274.322-1.903a4.649 4.649 0 00-.65-1.341s-.301 1.859-.206 2.652c.056.465.285.67.394.742-.103.11-.205.222-.313.331a16.231 16.231 0 01-1.735 1.515c.279-.375.652-.979.648-1.518a4.803 4.803 0 00-.287-1.485s-.771 1.695-.888 2.483c-.063.42.07.673.16.796a18.2 18.2 0 01-2.172 1.33c.3-.218 1.1-.862 1.238-1.538.15-.749.014-1.515.014-1.515s-1.122 1.48-1.41 2.221c-.2.51-.01.831.035.897-.77.398-1.58.746-2.418 1.047.399-.202 1.24-.684 1.474-1.286.28-.716.259-1.493.259-1.493s-1.407 1.29-1.839 1.975c-.29.46-.159.801-.12.885a21.72 21.72 0 01-3.034.808c-1.943.37-3.078 1.126-3.713 1.75.042.015.087.029.128.041.632-.602 1.737-1.318 3.605-1.67a21.613 21.613 0 003.024-.805c.014.101.104.462.653.607.826.218 3.027-.388 3.027-.388s-.697-.348-1.45-.528c-.542-.13-1.308.024-1.789.15.768-.284 1.51-.609 2.222-.974.01.044.12.452.706.523.8.096 2.775-.825 2.775-.825s-.713-.242-1.449-.31c-.55-.05-1.275.236-1.693.433.727-.392 1.42-.823 2.071-1.294.057.109.248.388.733.364.775-.038 2.537-1.27 2.537-1.27s-.725-.123-1.442-.07c-.35.027-.748.208-1.084.404.458-.37.891-.76 1.296-1.17.11-.112.216-.229.324-.344.069.095.298.338.769.223.744-.183 2.283-1.728 2.283-1.728s-.73.016-1.424.203c-.369.1-.761.393-1.072.67a14.563 14.563 0 001.603-2.366c.093.072.374.233.793-.008.674-.388 1.8-2.31 1.8-2.31s-.705.223-1.331.6c-.324.195-.623.568-.853.915l-.002-.001z",
    fill: "url(#Elitebadge_svg__paint16_linear_5736_26101)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.937 16.246s-.81-1.142-1.579-1.22c-.687-.073-1.366.16-1.366.16s1.444 1.033 2.133 1.235c.534.157.81-.175.81-.175h.002z",
    fill: "url(#Elitebadge_svg__paint17_linear_5736_26101)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 29.326s.357.245.814-.17c.59-.534 1.35-2.672 1.35-2.672s-.653.381-1.2.895c-.612.574-.965 1.947-.965 1.947z",
    fill: "url(#Elitebadge_svg__paint18_linear_5736_26101)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 31.622c.803-1.728 1.26-3.619 1.356-5.62.063.018.42.102.76-.362.482-.659.846-2.923.846-2.923s-.572.525-1.018 1.156c-.394.558-.54 1.562-.583 1.958.008-.205.014-.408.014-.615 0-.903-.074-1.797-.211-2.672.134-.024.403-.126.578-.568.31-.778.115-3.064.115-3.064s-.425.674-.703 1.414c-.143.381-.168.883-.156 1.315a16.682 16.682 0 00-.71-2.42c.106-.035.401-.175.507-.699.169-.832-.432-3.03-.432-3.03s-.295.755-.437 1.542c-.096.53.041 1.219.164 1.682a16.186 16.186 0 00-1.362-2.58c.077-.04.383-.23.39-.808.012-.853-1.013-2.87-1.013-2.87s-.143.803-.13 1.606c.009.67.416 1.502.619 1.877a16.1 16.1 0 00-1.111-1.463c-.097-.306-.401-1.026-1.259-1.582-1-.65-2.65-1.287-2.65-1.287s1.77 1.69 2.685 2.38c.544.412.993.567 1.173.615a15.716 15.716 0 012.562 4.19c-.237-.393-.612-.907-1.042-1.054-.65-.22-1.347-.142-1.347-.142s1.195 1.326 1.828 1.675c.375.206.654.102.766.04.366.978.642 1.997.818 3.043-.126-.411-.44-1.272-.938-1.572-.594-.359-1.286-.433-1.286-.433s.928 1.56 1.486 2.043c.368.317.686.232.774.199a17.16 17.16 0 01.186 3.4c-.014-.18-.137-1.46-.68-1.96-.52-.485-1.186-.71-1.186-.71s.645 1.735 1.113 2.331c.345.44.717.37.752.363a15.34 15.34 0 01-.506 3.233c.02-.29.075-1.456-.346-2.03-.433-.59-1.048-.959-1.048-.959s.347 1.848.706 2.536c.256.487.609.518.67.52a14.34 14.34 0 01-1.095 2.81c.091-.44.22-1.311-.043-1.855a4.378 4.378 0 00-.868-1.171s.03 1.889.266 2.644c.135.432.386.586.508.637a14.6 14.6 0 01-2.001 2.815c.162-.38.495-1.274.322-1.903a4.649 4.649 0 00-.65-1.341s-.301 1.859-.206 2.652c.056.465.285.67.394.742-.103.11-.205.222-.313.331a16.231 16.231 0 01-1.735 1.515c.279-.375.652-.979.648-1.518a4.803 4.803 0 00-.287-1.485s-.771 1.695-.888 2.483c-.063.42.07.673.16.796a18.2 18.2 0 01-2.172 1.33c.3-.218 1.1-.862 1.238-1.538.15-.749.014-1.515.014-1.515s-1.122 1.48-1.41 2.221c-.2.51-.01.831.035.897-.77.398-1.58.746-2.418 1.047.399-.202 1.24-.684 1.474-1.286.28-.716.259-1.493.259-1.493s-1.407 1.29-1.839 1.975c-.29.46-.159.801-.12.885a21.72 21.72 0 01-3.034.808c-1.943.37-3.078 1.126-3.713 1.75.042.015.087.029.128.041.632-.602 1.737-1.318 3.605-1.67a21.613 21.613 0 003.024-.805c.014.101.104.462.653.607.826.218 3.027-.388 3.027-.388s-.697-.348-1.45-.528c-.542-.13-1.308.024-1.789.15.768-.284 1.51-.609 2.222-.974.01.044.12.452.706.523.8.096 2.775-.825 2.775-.825s-.713-.242-1.449-.31c-.55-.05-1.275.236-1.693.433.727-.392 1.42-.823 2.071-1.294.057.109.248.388.733.364.775-.038 2.537-1.27 2.537-1.27s-.725-.123-1.442-.07c-.35.027-.748.208-1.084.404.458-.37.891-.76 1.296-1.17.11-.112.216-.229.324-.344.069.095.298.338.769.223.744-.183 2.283-1.728 2.283-1.728s-.73.016-1.424.203c-.369.1-.761.393-1.072.67a14.563 14.563 0 001.603-2.366c.093.072.374.233.793-.008.674-.388 1.8-2.31 1.8-2.31s-.705.223-1.331.6c-.324.195-.623.568-.853.915l-.002-.001z",
    fill: "url(#Elitebadge_svg__paint19_linear_5736_26101)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.724 16.246s.81-1.142 1.578-1.22c.687-.073 1.367.16 1.367.16s-1.444 1.033-2.133 1.235c-.535.157-.81-.175-.81-.175h-.002z",
    fill: "url(#Elitebadge_svg__paint20_linear_5736_26101)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.461 29.326s-.358.245-.815-.17c-.59-.534-1.35-2.672-1.35-2.672s.653.381 1.2.895c.612.574.965 1.947.965 1.947z",
    fill: "url(#Elitebadge_svg__paint21_linear_5736_26101)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 31.622c-.803-1.728-1.26-3.619-1.356-5.62-.063.018-.42.102-.76-.362-.482-.659-.847-2.923-.847-2.923s.573.525 1.019 1.156c.394.558.539 1.562.583 1.958a15.929 15.929 0 01-.014-.615c0-.903.074-1.797.211-2.672-.134-.024-.403-.126-.578-.568-.31-.778-.115-3.064-.115-3.064s.425.674.703 1.414c.143.381.168.883.156 1.315.176-.828.414-1.637.71-2.42-.106-.035-.401-.175-.507-.699-.169-.832.432-3.03.432-3.03s.295.755.437 1.542c.096.53-.041 1.219-.164 1.682.377-.902.832-1.766 1.362-2.58-.077-.04-.383-.23-.391-.808-.011-.853 1.014-2.87 1.014-2.87s.143.803.13 1.606c-.009.67-.416 1.502-.619 1.877.342-.507.713-.996 1.112-1.463.096-.306.4-1.026 1.258-1.582 1-.65 2.65-1.287 2.65-1.287s-1.77 1.69-2.685 2.38c-.544.412-.993.567-1.173.615a15.716 15.716 0 00-2.562 4.19c.237-.393.612-.907 1.042-1.054.65-.22 1.346-.142 1.346-.142s-1.195 1.326-1.827 1.675c-.375.206-.654.102-.766.04a16.523 16.523 0 00-.818 3.043c.126-.411.44-1.272.938-1.572.594-.359 1.286-.433 1.286-.433s-.928 1.56-1.486 2.043c-.368.317-.686.232-.774.199a17.156 17.156 0 00-.186 3.4c.014-.18.137-1.46.68-1.96a3.737 3.737 0 011.186-.71s-.645 1.735-1.113 2.331c-.345.44-.717.37-.752.363.055 1.116.227 2.196.506 3.233-.02-.29-.075-1.456.345-2.03a4.073 4.073 0 011.049-.959s-.347 1.848-.706 2.536c-.256.487-.609.518-.669.52.268.979.634 1.918 1.096 2.81-.092-.44-.22-1.311.042-1.855.327-.675.87-1.171.87-1.171s-.03 1.889-.267 2.644c-.136.432-.387.586-.508.637a14.604 14.604 0 002 2.815c-.162-.38-.494-1.274-.321-1.903.202-.733.65-1.341.65-1.341s.3 1.859.206 2.652c-.057.465-.285.67-.394.742.102.11.205.222.312.331.533.54 1.115 1.044 1.736 1.515-.28-.375-.653-.979-.648-1.518a4.803 4.803 0 01.287-1.485s.77 1.695.887 2.483c.063.42-.069.673-.159.796.68.487 1.408.932 2.171 1.33-.3-.218-1.1-.862-1.238-1.538-.15-.749-.014-1.515-.014-1.515s1.123 1.48 1.411 2.221c.199.51.01.831-.036.897.771.398 1.58.746 2.418 1.047-.398-.202-1.239-.684-1.474-1.286-.279-.716-.258-1.493-.258-1.493s1.406 1.29 1.838 1.975c.29.46.16.801.12.885.976.337 1.991.61 3.035.808 1.942.37 3.077 1.126 3.712 1.75a6.183 6.183 0 01-.127.041c-.632-.602-1.738-1.318-3.606-1.67a21.613 21.613 0 01-3.023-.805c-.015.101-.105.462-.653.607-.826.218-3.027-.388-3.027-.388s.697-.348 1.45-.528c.541-.13 1.307.024 1.788.15a20.057 20.057 0 01-2.221-.974c-.01.044-.12.452-.707.523-.799.096-2.774-.825-2.774-.825s.712-.242 1.449-.31c.55-.05 1.275.236 1.693.433a18.494 18.494 0 01-2.072-1.294c-.057.109-.247.388-.733.364-.774-.038-2.537-1.27-2.537-1.27s.726-.123 1.443-.07c.35.027.747.208 1.083.404-.457-.37-.89-.76-1.296-1.17-.11-.112-.216-.229-.323-.344-.07.095-.298.338-.77.223-.744-.183-2.282-1.728-2.282-1.728s.73.016 1.423.203c.37.1.762.393 1.072.67a14.563 14.563 0 01-1.603-2.366c-.093.072-.374.233-.793-.008-.673-.388-1.799-2.31-1.799-2.31s.705.223 1.33.6c.324.195.624.568.854.915v-.001z",
    fill: "url(#Elitebadge_svg__paint22_linear_5736_26101)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.724 16.246s.81-1.142 1.578-1.22c.687-.073 1.367.16 1.367.16s-1.444 1.033-2.133 1.235c-.535.157-.81-.175-.81-.175h-.002z",
    fill: "url(#Elitebadge_svg__paint23_linear_5736_26101)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.461 29.326s-.358.245-.815-.17c-.59-.534-1.35-2.672-1.35-2.672s.653.381 1.2.895c.612.574.965 1.947.965 1.947z",
    fill: "url(#Elitebadge_svg__paint24_linear_5736_26101)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 31.622c-.803-1.728-1.26-3.619-1.356-5.62-.063.018-.42.102-.76-.362-.482-.659-.847-2.923-.847-2.923s.573.525 1.019 1.156c.394.558.539 1.562.583 1.958a15.929 15.929 0 01-.014-.615c0-.903.074-1.797.211-2.672-.134-.024-.403-.126-.578-.568-.31-.778-.115-3.064-.115-3.064s.425.674.703 1.414c.143.381.168.883.156 1.315.176-.828.414-1.637.71-2.42-.106-.035-.401-.175-.507-.699-.169-.832.432-3.03.432-3.03s.295.755.437 1.542c.096.53-.041 1.219-.164 1.682.377-.902.832-1.766 1.362-2.58-.077-.04-.383-.23-.391-.808-.011-.853 1.014-2.87 1.014-2.87s.143.803.13 1.606c-.009.67-.416 1.502-.619 1.877.342-.507.713-.996 1.112-1.463.096-.306.4-1.026 1.258-1.582 1-.65 2.65-1.287 2.65-1.287s-1.77 1.69-2.685 2.38c-.544.412-.993.567-1.173.615a15.716 15.716 0 00-2.562 4.19c.237-.393.612-.907 1.042-1.054.65-.22 1.346-.142 1.346-.142s-1.195 1.326-1.827 1.675c-.375.206-.654.102-.766.04a16.523 16.523 0 00-.818 3.043c.126-.411.44-1.272.938-1.572.594-.359 1.286-.433 1.286-.433s-.928 1.56-1.486 2.043c-.368.317-.686.232-.774.199a17.156 17.156 0 00-.186 3.4c.014-.18.137-1.46.68-1.96a3.737 3.737 0 011.186-.71s-.645 1.735-1.113 2.331c-.345.44-.717.37-.752.363.055 1.116.227 2.196.506 3.233-.02-.29-.075-1.456.345-2.03a4.073 4.073 0 011.049-.959s-.347 1.848-.706 2.536c-.256.487-.609.518-.669.52.268.979.634 1.918 1.096 2.81-.092-.44-.22-1.311.042-1.855.327-.675.87-1.171.87-1.171s-.03 1.889-.267 2.644c-.136.432-.387.586-.508.637a14.604 14.604 0 002 2.815c-.162-.38-.494-1.274-.321-1.903.202-.733.65-1.341.65-1.341s.3 1.859.206 2.652c-.057.465-.285.67-.394.742.102.11.205.222.312.331.533.54 1.115 1.044 1.736 1.515-.28-.375-.653-.979-.648-1.518a4.803 4.803 0 01.287-1.485s.77 1.695.887 2.483c.063.42-.069.673-.159.796.68.487 1.408.932 2.171 1.33-.3-.218-1.1-.862-1.238-1.538-.15-.749-.014-1.515-.014-1.515s1.123 1.48 1.411 2.221c.199.51.01.831-.036.897.771.398 1.58.746 2.418 1.047-.398-.202-1.239-.684-1.474-1.286-.279-.716-.258-1.493-.258-1.493s1.406 1.29 1.838 1.975c.29.46.16.801.12.885.976.337 1.991.61 3.035.808 1.942.37 3.077 1.126 3.712 1.75a6.183 6.183 0 01-.127.041c-.632-.602-1.738-1.318-3.606-1.67a21.613 21.613 0 01-3.023-.805c-.015.101-.105.462-.653.607-.826.218-3.027-.388-3.027-.388s.697-.348 1.45-.528c.541-.13 1.307.024 1.788.15a20.057 20.057 0 01-2.221-.974c-.01.044-.12.452-.707.523-.799.096-2.774-.825-2.774-.825s.712-.242 1.449-.31c.55-.05 1.275.236 1.693.433a18.494 18.494 0 01-2.072-1.294c-.057.109-.247.388-.733.364-.774-.038-2.537-1.27-2.537-1.27s.726-.123 1.443-.07c.35.027.747.208 1.083.404-.457-.37-.89-.76-1.296-1.17-.11-.112-.216-.229-.323-.344-.07.095-.298.338-.77.223-.744-.183-2.282-1.728-2.282-1.728s.73.016 1.423.203c.37.1.762.393 1.072.67a14.563 14.563 0 01-1.603-2.366c-.093.072-.374.233-.793-.008-.673-.388-1.799-2.31-1.799-2.31s.705.223 1.33.6c.324.195.624.568.854.915v-.001z",
    fill: "url(#Elitebadge_svg__paint25_linear_5736_26101)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.602 7.939l-.47-1.17-.47 1.17-1.258.085.968.809-.307 1.222 1.067-.67 1.067.67-.307-1.222.968-.809-1.258-.085z",
    fill: "url(#Elitebadge_svg__paint26_linear_5736_26101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.889 9.742l-.614.243-.485-.448.04.66-.576.323.64.165.13.647.354-.557.656.077-.421-.509.276-.6z",
    fill: "url(#Elitebadge_svg__paint27_linear_5736_26101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M21.32 8.51l-.566-.727-.094.916-.867.313.841.374.03.92.617-.685.884.257-.462-.798.52-.763-.903.193z",
    fill: "url(#Elitebadge_svg__paint28_linear_5736_26101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M32.389 10.197l.04-.66-.485.448-.615-.243.276.601-.42.51.657-.078.355.557.129-.647.638-.165-.575-.323z",
    fill: "url(#Elitebadge_svg__paint29_linear_5736_26101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.466 7.783l-.566.727-.902-.193.517.763-.462.798.886-.257.616.686.03-.92.842-.375-.867-.313-.094-.916z",
    fill: "url(#Elitebadge_svg__paint30_linear_5736_26101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint0_linear_5736_26101",
    x1: 31.822,
    y1: 3.64,
    x2: 15.559,
    y2: 56.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BD8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E0BE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint1_linear_5736_26101",
    x1: 7.727,
    y1: 5.861,
    x2: 42.949,
    y2: 43.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BD8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E0BE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint2_linear_5736_26101",
    x1: 8.566,
    y1: 6.753,
    x2: 42.115,
    y2: 42.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05224C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2D62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint3_linear_5736_26101",
    x1: 33.775,
    y1: 0.097,
    x2: 6.103,
    y2: 81.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BD8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E0BE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint14_linear_5736_26101",
    x1: 20.28,
    y1: 49.903,
    x2: 49.279,
    y2: -7.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint15_linear_5736_26101",
    x1: 29.011,
    y1: 54.292,
    x2: 58.01,
    y2: -3.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint16_linear_5736_26101",
    x1: 23.048,
    y1: 51.295,
    x2: 52.047,
    y2: -6.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint17_linear_5736_26101",
    x1: 20.28,
    y1: 49.903,
    x2: 49.279,
    y2: -7.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint18_linear_5736_26101",
    x1: 29.011,
    y1: 54.292,
    x2: 58.01,
    y2: -3.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint19_linear_5736_26101",
    x1: 23.048,
    y1: 51.295,
    x2: 52.047,
    y2: -6.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint20_linear_5736_26101",
    x1: 30.381,
    y1: 49.903,
    x2: 1.382,
    y2: -7.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint21_linear_5736_26101",
    x1: 21.649,
    y1: 54.292,
    x2: -7.349,
    y2: -3.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint22_linear_5736_26101",
    x1: 27.612,
    y1: 51.295,
    x2: -1.387,
    y2: -6.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint23_linear_5736_26101",
    x1: 30.381,
    y1: 49.903,
    x2: 1.382,
    y2: -7.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint24_linear_5736_26101",
    x1: 21.649,
    y1: 54.292,
    x2: -7.349,
    y2: -3.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint25_linear_5736_26101",
    x1: 27.612,
    y1: 51.295,
    x2: -1.387,
    y2: -6.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint26_linear_5736_26101",
    x1: 23.699,
    y1: 14.783,
    x2: 26.319,
    y2: 2.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint27_linear_5736_26101",
    x1: 17.552,
    y1: 13.479,
    x2: 20.174,
    y2: 1.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint28_linear_5736_26101",
    x1: 20.012,
    y1: 14.001,
    x2: 22.634,
    y2: 1.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint29_linear_5736_26101",
    x1: 30.839,
    y1: 16.298,
    x2: 33.461,
    y2: 3.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Elitebadge_svg__paint30_linear_5736_26101",
    x1: 27.733,
    y1: 15.639,
    x2: 30.355,
    y2: 3.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#875900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AA8F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C0B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C9BF85"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint4_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint5_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint6_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint7_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint8_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint9_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint10_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint11_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.193) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint12_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.195) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Elitebadge_svg__paint13_radial_5736_26101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.985 44.193) scale(37.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFF5A8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Elitebadge_svg__clip0_5736_26101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h51.882v49H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elitebadge_svg__filter0_d_5736_26101",
    x: 1.956,
    y: 2.151,
    width: 50.091,
    height: 48.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.62,
    dy: 1.62
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.157
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5736_26101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5736_26101",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/Elitebadge.d198fa44.svg";
export { SvgElitebadge as ReactComponent };